import { CBCS } from './CBCS.js';
import { CENC } from './CENC.js';
/**
 * Encryption schemes.
 *
 * @group DRM
 *
 * @beta
 */
export const EncryptionScheme = {
    CENC: CENC,
    CBCS: CBCS,
};
//# sourceMappingURL=EncryptionScheme.js.map